import { apiClient } from './client';
import type { SearchResponse, SearchSuggestionsResponse } from '@affogato/shared';

export const searchApi = {
  async search(
    query: string,
    options?: {
      type?: 'file' | 'folder' | 'client' | 'all';
      clientId?: string;
      limit?: number;
    }
  ): Promise<SearchResponse> {
    const params = new URLSearchParams();
    params.append('q', query);
    if (options?.type) params.append('type', options.type);
    if (options?.clientId) params.append('client_id', options.clientId);
    if (options?.limit) params.append('limit', options.limit.toString());

    return apiClient.get(`/search?${params.toString()}`);
  },

  async getSuggestions(query: string): Promise<SearchSuggestionsResponse> {
    return apiClient.get(`/search/suggestions?q=${encodeURIComponent(query)}`);
  },
};
